/**
 * data-export-report-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AggVariable } from "../../../aggregation/typed-parameter";
import { AggregationDataType } from "../../../common/data/data-types";
import { KnownSubjectContextTypes, SubjectContextType }
  from "../../../subjects/subject-context-type";

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

// TODO: naming is odder in the dexport case
@validateFor(MessageTag.RSP_DATA_EXPORT_REPORT)
export class DataExportReportResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_DATA_EXPORT_REPORT;

  @validateOpaqueID()
  public exportId : number;
  @validateOpaqueID()
  public groupId : number;
  @validateAs("string")
  public exportName : string;

  @validateAs({enum: Object.values(KnownSubjectContextTypes)})
  public subjectContextType : SubjectContextType;

  @validateAs("integer")
  public processed : number;
  @validateAs("integer")
  public rejected : number;
  @validateAs("integer")
  public viable : number;
  @validateAs("integer")
  public recordCount : number;

  @validateAs("integer")
  public start : number;
  @validateAs("integer")
  public ended : number;
  @validateAs("integer")
  public duration : number;
  @validateAs("integer")
  public paused : number;

  @validateAs("string")
  public export : string;

  @validateAs("integer")
  public bytesSent : number;

  @validateAs("integer")
  public checksum : number;

  public get checksumUnsigned () : number
  {
    // tslint:disable-next-line:no-bitwise
    return this.checksum & 0xFFFFFFFF;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/data-export-report-response.ts